import { getMyFeed } from 'services/feed';
import { normalizeFeed } from 'services/helpers/feed';
import { showErrorSnackbar } from 'services/snackbar';

import {
  ADD_FEED,
  UPDATE_FEED,
  ADD_COMMENTS_TO_FEED,
  UPDATE_FEED_COMMENTS,
  CLEAR_FEED,
  UPDATE_FEED_COMMENT,
  UPDATE_FEED_TALKING_POINT_COMMENT,
  UPDATE_FEED_ITEM,
} from './actionTypes';

export function addFeedAction(feed) {
  return (dispatch) => {
    dispatch({
      type: ADD_FEED,
      data: feed,
    });
  };
}

// feed item means a particular post
export function updateFeedItemAction(postId, post) {
  return {
    type: UPDATE_FEED_ITEM,
    postId,
    post,
  };
}

export function updateFeedAction(feed) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_FEED,
      data: feed,
    });
  };
}

// Not used anywhere

// export function loadMoreFeedAction({ employeeId, limit, offset, pageType, callback }) {
//   return dispatch => {
//     getMyFeed({ employeeId, limit, offset, pageType }).then(feed => {
//       const normalizedFeed = normalizeFeed(feed);
//       dispatch(addFeedAction(normalizedFeed));
//       callback();
//     });
//   };
// }

export function addCommentsToFeed({ feedId, comments, append = false }) {
  return function (dispatch) {
    dispatch({
      type: ADD_COMMENTS_TO_FEED,
      data: {
        comments,
        feedId,
        append,
      },
    });
  };
}

export function updateFeedCommentsAction({ feedId, comments }) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_FEED_COMMENTS,
      data: {
        comments,
        feedId,
      },
    });
  };
}

export function updateFeedCommentAction({ commentId, comment }) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_FEED_COMMENT,
      commentId,
      comment,
    });
  };
}

export function updateFeedTalkingPointCommentAction({ commentId, comment, talkingPointQuestionId }) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_FEED_TALKING_POINT_COMMENT,
      commentId,
      comment,
      talkingPointQuestionId,
    });
  };
}

export function reloadFeedAction({ employeeId, pageType, onSuccess, onError }) {
  return function (dispatch) {
    getMyFeed({ employeeId, pageType })
      .then((feed) => {
        const normalizedFeed = normalizeFeed(feed);
        dispatch(updateFeedAction(normalizedFeed));
        // doing this for onboarding, refreshing feed after task creation
        // and then we need the feed for the next step
        if (onSuccess) {
          setTimeout(() => {
            onSuccess();
          }, 500);
        }
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'An error occured while fetching feed'));
        if (onError) {
          onError();
        }
      });
  };
}

export function clearFeedAction() {
  return {
    type: CLEAR_FEED,
  };
}
